import React, {useContext} from "react";
import "./DigitalTwins.scss";
import {digitalTwinsSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";

export default function DigitalTwins() {
  const {isDark} = useContext(StyleContext);
  
  return (
    <div className="main" id="digitalTwins">
      <div className="digital-twins-main-div">
        <div className="digital-twins-text-div">
          <h1 className="digital-twins-heading">
            {digitalTwinsSection.title}
          </h1>
          <p className={isDark ? "dark-mode digital-twins-text" : "digital-twins-text"}>
            {digitalTwinsSection.description}
          </p>
          <div className="software-skills-container">
            <h2>Technologies We Use</h2>
            {digitalTwinsSection.softwareSkills && (
              <SoftwareSkill logos={digitalTwinsSection.softwareSkills} />
            )}
          </div>
        </div>
        <div className="digital-twins-image-div">
          {digitalTwinsSection.gifUrl && (
            <img
              alt="Digital Twin Simulation"
              src={digitalTwinsSection.gifUrl}
            />
          )}
        </div>
      </div>
    </div>
  );
}
